import { ref, reactive , inject, provide } from 'vue'
import api from './modules/api'
import ui from './modules/ui'
import browser from './modules/browser'

/**
 * vue3 Composition API機能を使いstoreを作成する
 * 
 * 参考 Vue3のinject/provideでミニマルなストアを作る
 * https://ushirock.hateblo.jp/entry/2020/05/29/214752
 */

 const config = {
   STATIC_MAPDATA_IMG_PATH : '/static/mapdata/img/'
 }

export const key = 'key'

export const createStore = () => {
  return {
    api,
    ui,
    browser,
    config
  }
}

export const provideStore = () => {
  provide(key, createStore())
}

export const useStore = () => {
  return inject(key)
}